import Translator from "@/types/services/Translator";

class Validator {
    isValidText(text: string): boolean {
        return /^[a-zA-Z\u00C0-\u024F\s'-]+$/.test(text);
    }

    isValidTextNumber(text: string): boolean {
      return /^[a-zA-Z0-9\u00C0-\u024F\s'-]+$/.test(text);
    }

    isValidPhoneNumber(phoneNumber: string): boolean {
        return /^[+]?[(]?[0-9]{1,4}[)]?[-\s0-9]*$/.test(phoneNumber);
    }

    isValidEmail(email: string): boolean {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    isNonEmpty(value: string): boolean {
        return !!value.trim();
    }

    textRule(value: string): string|true {
        if (!this.isNonEmpty(value)) return Translator.trans("validator.required");
        if (!this.isValidText(value)) return Translator.trans("validator.alphabetic");
        return true;
    }

    textNumberRule(value: string): string|true {
        if (!this.isNonEmpty(value)) return Translator.trans("validator.required");
        if (!this.isValidTextNumber(value)) return Translator.trans("validator.alphanumeric");
        return true;
    }

    phoneNumberRule(value: string): string|true {
        if (!this.isNonEmpty(value)) return Translator.trans("validator.required");
        if (!this.isValidPhoneNumber(value)) return Translator.trans("validator.phone");
        return true;
    }

    emailRule(value: string): string|true {
        if (!this.isNonEmpty(value)) return Translator.trans("validator.required");
        if (!this.isValidEmail(value)) return Translator.trans("validator.email");
        return true;
    }
    isValidIdNumber(id: string): boolean {
      return /^[a-zA-Z0-9]{6,9}$/.test(id);
    }

    idNumberRule(value: string): string | true {
      if (!this.isNonEmpty(value)) return Translator.trans("validator.required");
      if (!this.isValidIdNumber(value)) return Translator.trans("validator.id_number");
      return true;
    }

}

export default new Validator();
